/**
 * Vendor Auth Context
 *
 * 공급사 앱의 인증 값 모양. 제공자는 씨마켓 임베드 토큰으로 세션을 여는 `EmbedAuthProvider` 하나다
 * (공급사 앱은 임베드 전용 — 별도의 로그인 대시보드는 없앴다).
 */

import { createContext } from "react";
import type { UserInfoDto, SupplierInfoDto } from "@semo/api-contracts";

export interface VendorAuthContextType {
  currentUser: UserInfoDto | null;
  supplierInfo: SupplierInfoDto | null;
  isLoading: boolean;
  isSessionLoading: boolean;
  logout: () => Promise<void>;
  setCurrentUser: (user: UserInfoDto | null) => void;
  checkSession: () => void;
}

export const VendorAuthContext = createContext<
  VendorAuthContextType | undefined
>(undefined);
VendorAuthContext.displayName = "VendorAuthContext";
